import { MatchClientModel } from '@sport1/types/sportData'
import Types, { CompetitorProps } from '@sport1/news-styleguide/Types'
import canOpenTeam from '@/utils/sportsData/canOpenTeam'

const getCompetitors = (
    initialMatch: MatchClientModel,
    matchProps:
        | Omit<Types.PreMatchProps, 'onPressMatch'>
        | Types.PostMatchProps
        | Omit<Types.LiveMatchProps, 'onPressMatch'>
): {
    homeCompetitor: CompetitorProps
    awayCompetitor: CompetitorProps
} => {
    const homeName =
        initialMatch.homeTeam?.name ||
        initialMatch.homeTeam?.shortName ||
        matchProps.homeCompetitor.name
    const awayName =
        initialMatch.awayTeam?.name ||
        initialMatch.awayTeam?.shortName ||
        matchProps.awayCompetitor.name
    return {
        homeCompetitor: {
            ...matchProps?.homeCompetitor,
            name: homeName,
            shortName: initialMatch.homeTeam?.shortName,
            href: canOpenTeam(initialMatch.homeTeam) ? matchProps.homeCompetitor.href : undefined,
        },
        awayCompetitor: {
            ...matchProps?.awayCompetitor,
            name: awayName,
            shortName: initialMatch.awayTeam?.shortName,
            href: canOpenTeam(initialMatch.awayTeam) ? matchProps.awayCompetitor.href : undefined,
        },
    }
}

export default getCompetitors
